import { http } from '../request'
import type { PaginationData } from '../request'
import type {
    Role,
    RoleListRequest,
    RoleCreateRequest,
    RoleUpdateRequest,
    RolePermissionAssignRequest,
    RolePermissionRevokeRequest,
    RolePermissionAssignResponse,
    RolePermissionRevokeResponse,
    UserRoleAssignRequest,
    UserRoleRevokeRequest,
    UserRoleAssignResponse,
    UserRoleRevokeResponse,
    UserRoleListRequest,
    UserRoleListItem,
    RolePermissionsResponse,
    RoleUsersResponse
} from '../types_admin/roles'

/**
 * 管理员角色管理 API
 */
export const adminRolesApi = {
    /**
     * 获取角色列表
     * GET /api/permissions/roles/
     */
    getRoleList(params?: RoleListRequest): Promise<PaginationData<Role>> {
        return http.list('/api/permissions/roles/', params)
    },

    /**
     * 创建角色
     * POST /api/permissions/roles/
     */
    createRole(data: RoleCreateRequest): Promise<Role> {
        return http.post('/api/permissions/roles/', data)
    },

    /**
     * 更新角色
     * PUT /api/permissions/roles/{id}/
     */
    updateRole(id: number, data: RoleUpdateRequest): Promise<Role> {
        return http.put(`/api/permissions/roles/${id}/`, data)
    },

    /**
     * 删除角色
     * DELETE /api/permissions/roles/{id}/
     */
    deleteRole(id: number): Promise<void> {
        return http.delete(`/api/permissions/roles/${id}/`)
    },

    /**
     * 给角色分配权限（仅超管）
     * POST /api/permissions/roles/{id}/assign-permissions/
     */
    assignPermissions(id: number, data: RolePermissionAssignRequest): Promise<RolePermissionAssignResponse> {
        return http.post(`/api/permissions/roles/${id}/assign-permissions/`, data)
    },

    /**
     * 撤销角色权限（仅超管）
     * POST /api/permissions/roles/{id}/revoke-permissions/
     */
    revokePermissions(id: number, data: RolePermissionRevokeRequest): Promise<RolePermissionRevokeResponse> {
        return http.post(`/api/permissions/roles/${id}/revoke-permissions/`, data)
    },

    /**
     * 获取角色的权限列表
     * GET /api/permissions/roles/{id}/permissions/
     */
    getRolePermissions(id: number): Promise<RolePermissionsResponse> {
        return http.get(`/api/permissions/roles/${id}/permissions/`)
    },

    /**
     * 获取角色的用户列表
     * GET /api/permissions/roles/{id}/users/
     */
    getRoleUsers(id: number): Promise<RoleUsersResponse> {
        return http.get(`/api/permissions/roles/${id}/users/`)
    },

    /**
     * 批量分配用户角色
     * POST /api/permissions/user-roles/assign-roles/
     */
    assignUserRoles(data: UserRoleAssignRequest): Promise<UserRoleAssignResponse> {
        return http.post('/api/permissions/user-roles/assign-roles/', data)
    },

    /**
     * 批量撤销用户角色
     * POST /api/permissions/user-roles/revoke-roles/
     */
    revokeUserRoles(data: UserRoleRevokeRequest): Promise<UserRoleRevokeResponse> {
        return http.post('/api/permissions/user-roles/revoke-roles/', data)
    },

    /**
     * 获取用户角色分配列表
     * GET /api/permissions/user-roles/
     */
    getUserRolesList(params?: UserRoleListRequest): Promise<PaginationData<UserRoleListItem>> {
        return http.list('/api/permissions/user-roles/', params)
    }
    ,
    /**
     * 更新单个用户角色分配
     * PUT /api/permissions/user-roles/{id}/
     */
    updateUserRole(id: number, data: Partial<{ role: number; expires_at: string | null; is_active: boolean; description: string }>): Promise<UserRoleListItem> {
        return http.put(`/api/permissions/user-roles/${id}/`, data)
    }
}